var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"text-center display-4 mt-3"},[_vm._v("Mortgage Calculator")]),_c('Fields')],1)}
var staticRenderFns = []

export { render, staticRenderFns }